/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S17_HeadingInputs */

const tr_kullanim_s17_heading = /** @type {(inputs: Kullanim_S17_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`17. Gizlilik`)
};

const en_kullanim_s17_heading = /** @type {(inputs: Kullanim_S17_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`17. Confidentiality`)
};

const de_kullanim_s17_heading = /** @type {(inputs: Kullanim_S17_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`17. Vertraulichkeit`)
};

const ru_kullanim_s17_heading = /** @type {(inputs: Kullanim_S17_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`17. Конфиденциальность`)
};

/**
* | output |
* | --- |
* | "17. Confidentiality" |
*
* @param {Kullanim_S17_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s17_heading = /** @type {((inputs?: Kullanim_S17_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S17_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s17_heading(inputs)
	if (locale === "de") return de_kullanim_s17_heading(inputs)
	if (locale === "ru") return ru_kullanim_s17_heading(inputs)
	return tr_kullanim_s17_heading(inputs)
});